<template>
  <div
    v-if="game && game.id"
    class="filters">
    <div class="frequent-filters-head">
      <b-button
        v-if="showFiltersButton"
        class="btn filter-button"
        @click="openSideBar">
        <img src="/svg/filter-button.svg">Фильтры
      </b-button>

      <div
        id="frequent-filters"
        class="frequent-filters">
        <frequent-filter
          v-for="(attribute, attributeIndex) in filterAttributesNoAffects"
          v-show="
            attribute.is_frequent == 1 ||
              ((!attribute.is_frequent || attribute.is_frequent == 0) &&
              attribute.filters &&
              attribute.filters.nothing == false) ||
              !showFiltersButton
          "
          :ref="'frequent-filter-' + attribute.id"
          :key="'frequent-filter-' + attributeIndex + '-' + filtersKey"
          container="frequent-filters"
          :attribute="attribute"/>
        <frequent-filter
          v-for="(attribute, attributeIndex) in filterPriceAndTimeAttributes"
          v-show="
            attribute.is_frequent == 1 ||
              ((!attribute.is_frequent || attribute.is_frequent == 0) &&
              attribute.filters &&
              attribute.filters.nothing == false) ||
              !showFiltersButton
          "
          :ref="'frequent-filter-' + attribute.id"
          :key="'frequent-filter-' + attributeIndex + '-' + filtersKey"
          container="frequent-filters"
          :attribute="attribute"/>
      </div>

      <img
        v-show="canDiscard"
        class="discard-all"
        src="/svg/close-all-filters.svg"
        @click="discardFilters">
    </div>
    <div
      v-show="showSideBar"
      id="filters-sidebar"
      ref="sidebar"
      class="filters-sidebar">
      <div class="sidebar-content-wrapper">
        <div
          v-stick-in-parent="stiсkyKit"
          class="sidebar-content">
          <div
            v-show="
              filterAttributesNoAffects && filterAttributesNoAffects.length > 0
            "
            class="sidebar-header">
            <div class="d-flex align-items-center">
              <img
                src="/svg/filter-blue.svg"
                class="blue-filter">
              <span class="sidebar-title">Фильтровать по</span>
            </div>
            <img
              class="close-sidebar"
              src="/svg/close-popover.svg"
              @click="closeSideBar">
          </div>
          <div
            v-show="
              filterAttributesNoAffects && filterAttributesNoAffects.length > 0
            "
            class="sidebar-filters">
            <frequent-filter
              v-for="(attribute, attributeIndex) in filterAttributesNoAffects"
              :ref="'filterAttributesNoAffects-' + attribute.id"
              :key="
                'filterAttributesNoAffects-' + attributeIndex + '-' + filtersKey
              "
              container="filters-sidebar"
              :attribute="attribute"/>
          </div>
          <div
            v-show="
              filterPriceAndTimeAttributes &&
                filterPriceAndTimeAttributes.length > 0
            "
            class="sidebar-header sidebar-header-second">
            <div class="d-flex align-items-center">
              <img
                src="/svg/filter-blue.svg"
                class="blue-filter">
              <span class="sidebar-title">Рассчитать цены и сроки</span>
            </div>
          </div>
          <div
            v-show="
              filterPriceAndTimeAttributes &&
                filterPriceAndTimeAttributes.length > 0
            "
            class="sidebar-filters">
            <frequent-filter
              v-for="(
                attribute, attributeIndex
              ) in filterPriceAndTimeAttributes"
              :ref="'filterPriceAndTimeAttributes-' + attribute.id"
              :key="
                'filterPriceAndTimeAttributes-' +
                  attributeIndex +
                  '-' +
                  filtersKey
              "
              container="filters-sidebar"
              :attribute="attribute"/>
          </div>
        </div>
        <div class="sidebar-footer">
          <b-button
            class="btn close-button"
            :disabled="!canDiscard"
            @click="discardFilters">
            Сбросить все
          </b-button>
        </div>
      </div>
    </div>
    <div
      v-if="showSideBar"
      class="sidebar-overlay"
      @click="closeSideBar"/>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import frequentFilter from "~/components/offer/filters/frequentFilter.vue";
import FrequentFilter from "./frequentFilter.vue";
import VueStickyKit from "vue-stickykit";
Vue.use(VueStickyKit);
export default {
  components: {
    frequentFilter,
  },
  props: {
    user: {
      type: Object,
      default: null,
    },
    game: {
      type: Object,
      default: null,
    },
    categories: {
      type: Array,
      default: null,
    },
    usePageRoute: {
      type: Boolean,
      default: false,
    },
    path: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      backendUrl: process.env.backendUrl,
      showSideBar: false,
      filtersKey: new Date().toString(),
      canDiscard: false,
      stiсkyKit: {
        options: {
          offset_top: 64,
          bottoming: true,
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      calculateCategoryAttrs: "offerList/getCalculateCategoryAttrs",
      calculateCategoryOffers: "offerList/getCalculateCategoryOffers",
      activeCategory: "offerList/getActiveCategory",
    }),
    filterPriceAndTimeAttributes() {
      return this.activeCategory && this.activeCategory.attrs
        ? this.activeCategory.attrs.filter(
            (item) => item.affects_time == 1 || item.affects_price == 1
          )
        : null;
    },

    filterAttributesNoAffects() {
      return this.activeCategory && this.activeCategory.attrs
        ? this.activeCategory.attrs.filter(
            (item) =>
              item.is_filter == 1 &&
              item.affects_time == 0 &&
              item.affects_price == 0
          )
        : null;
    },
    showFiltersButton() {
      let length = 0;
      if (this.filterPriceAndTimeAttributes) {
        length = length + this.filterPriceAndTimeAttributes.length;
      }
      if (this.filterAttributesNoAffects) {
        length = length + this.filterAttributesNoAffects.length;
      }

      return length > 4;
    },

    frequentAttributes() {
      return this.activeCategory && this.activeCategory.attrs
        ? this.activeCategory.attrs.filter(
            (item) =>
              item.is_frequent == 1 ||
              (item.is_frequent == 0 &&
                item.filters &&
                item.filters.nothing == false)
          )
        : null;
    },
  },
  mounted() {
    let _this = this;

    document.addEventListener("scroll", (event) => {
      _this.setSidebarContentDimensions();
    });
  },
  methods: {
    setSidebarContentDimensions() {
      let _this = this;
      let sidebar = document.querySelector(".filters-sidebar");
      let sidebarFooter = document.querySelector(".sidebar-footer");
      let sidebarContent = document.querySelector(".sidebar-content");
      let header = document.querySelector(".header");
      if (
        this.$route.name === "games-game-category" ||
        this.$route.name === "profile-userId"
      ) {
        let fromTop = window.scrollY;

        if (!sidebar) {
          return;
        }

        function elementInViewport(el) {
          var bounding = el.getBoundingClientRect();

          if (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.right <=
              (window.innerWidth || document.documentElement.clientWidth) &&
            bounding.bottom <=
              (window.innerHeight || document.documentElement.clientHeight)
          ) {
            return true;
          } else {
            return false;
          }
        }

        if (
          (sidebarFooter.getBoundingClientRect().bottom +
            sidebarFooter.getBoundingClientRect().height >=
            sidebar.getBoundingClientRect().bottom &&
            elementInViewport(sidebarFooter) &&
            fromTop != 0) ||
          sidebar.getBoundingClientRect().bottom <
            (window.innerHeight || document.documentElement.clientHeight)
        ) {
          sidebarFooter.classList.add("stuck");
        } else {
          sidebarFooter.classList.remove("stuck");
        }

        if (sidebarFooter.classList.contains("stuck") && _this.showSideBar) {
          sidebarContent.classList.add("stuck");
          if (
            sidebar.getBoundingClientRect().top <= 0 &&
            sidebar.getBoundingClientRect().height -
              sidebar.getBoundingClientRect().top * -1 <
              sidebarContent.getBoundingClientRect().height +
                sidebarFooter.getBoundingClientRect().height
          ) {
            sidebarContent.style.position = "absolute";
            sidebarContent.style.top = "auto";
            sidebarContent.style.maxHeight = "calc(100% - " + 78 + "px)";
          } else {
            sidebarContent.style.position = "fixed";
            sidebarContent.style.top = "64px";
            sidebarContent.style.maxHeight = sidebar.scrollTop - 78 + "px";
          }
          if (
            sidebar.getBoundingClientRect().top >
            sidebarContent.getBoundingClientRect().top
          ) {
            sidebarContent.style.position = "absolute";
            sidebarContent.style.top = "0";
            sidebarContent.style.maxHeight = "calc(100% - " + 78 + "px)";
          }
        } else {
          sidebarContent.classList.remove("stuck");
          if (
            (sidebar.getBoundingClientRect().top >=
              header.getBoundingClientRect().height &&
              _this.showSideBar) ||
            !_this.showSideBar
          ) {
            sidebarContent.style.position = "relative";
            sidebarContent.style.top = "0";
            sidebarContent.style.maxHeight =
              window.innerHeight - 78 - sidebar.offsetTop + "px";
          } else {
            sidebarContent.style.position = "fixed";
            sidebarContent.style.top = "64px";
            sidebarContent.style.maxHeight = sidebar.scrollTop - 78 + "px";
          }
        }
      }
    },
    async discardFilters() {
      let _this = this;
      Object.keys(this.$refs).forEach((ref) => {
        if (_this.$refs[ref] && _this.$refs[ref][0]) {
          _this.$refs[ref][0].discardAll();
        }
      });

      this.$forceUpdate();
      this.$parent.$parent.updateFilters();
    },
    openSideBar() {
      this.showSideBar = true;
      let _this = this;

      setTimeout((x) => {
        if (_this.$refs && _this.$refs.sidebar) {
          _this.$nextTick(() => {
            let sidebar = document.querySelector(".filters-sidebar");
            let sidebarFooter = document.querySelector(".sidebar-footer");
            let sidebarContent = document.querySelector(".sidebar-content");
            let header = document.querySelector(".header");
            if (sidebar.getBoundingClientRect().height <= window.innerHeight) {
              sidebarContent.style.height =
                sidebar.getBoundingClientRect().height - 78 + "px";
            } else {
              sidebarContent.style.height =
                window.innerHeight -
                header.getBoundingClientRect().height -
                78 +
                "px";
            }
            _this.setSidebarContentDimensions();
            _this.$refs.sidebar.focus();
          });
        }
      }, 500);
    },
    closeSideBar() {
      this.showSideBar = false;
    },
    updateFiltersKey() {
      if (!this.activeCategory.attrs) {
        this.canDiscard = false;
      }

      this.canDiscard =
        this.activeCategory.attrs.filter(
          (item) => item.filters && item.filters.nothing == false
        ).length > 0;

      let _this = this;
      Object.keys(this.$refs).forEach((ref) => {
        if (_this.$refs[ref] && _this.$refs[ref][0]) {
          _this.$refs[ref][0].updateFiltersKey();
        }
      });
      if (this.showSideBar == true) {
        setTimeout((x) => {
          if (_this.$refs && _this.$refs.sidebar) {
            _this.$nextTick(() => {
              let sidebar = document.querySelector(".filters-sidebar");
              let sidebarFooter = document.querySelector(".sidebar-footer");
              let sidebarContent = document.querySelector(".sidebar-content");
              let header = document.querySelector(".header");
              if (
                sidebar.getBoundingClientRect().height <= window.innerHeight
              ) {
                sidebarContent.style.height =
                  sidebar.getBoundingClientRect().height - 78 + "px";
              } else {
                sidebarContent.style.height =
                  window.innerHeight -
                  header.getBoundingClientRect().height -
                  78 +
                  "px";
              }
              _this.setSidebarContentDimensions();
              _this.$refs.sidebar.focus();
            });
          }
        }, 500);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.filters {
  margin-top: -2px;
  border-top: 2px solid #eff1f4;
  display: flex;
  .filter-button-column {
    width: 124px;
  }

  .filter-button {
    height: 48px;
    width: 124px;
    background: #098aff;
    font-family: "Lato";
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0;
    box-shadow: none;
    padding-right: 12px;

    &:hover {
      background: #006ce1;
    }

    img {
      width: 18px;
      height: 18px;
      margin-right: 10px;
    }
  }

  .discard-all {
    cursor: pointer;
    padding-left: 12px;
    margin-right: 16px;
  }

  .frequent-filters {
    padding-top: 9px;
    padding-left: 12px;
    padding-right: 12px;
    flex-wrap: wrap;
    width: 100%;
    display: flex;
  }
}
.frequent-filters-head {
  display: flex;
  width: 100%;
}
.sidebar-overlay {
  position: absolute;
  z-index: 9;
  height: 100%;
  top: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.sidebar-content-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  top: 0;
}
.filters-sidebar {
  position: absolute;
  z-index: 10;
  display: flex;
  flex-direction: column;
  background: white;
  width: 364px;
  top: 0;
  height: 100%;

  overflow-x: hidden;
  overflow-y: auto;
  &::-webkit-scrollbar-thumb {
    background-color: #3e4356;
    margin: 5px 0px 5px 0;
    cursor: pointer;
    border: 5px solid rgba(0, 0, 0, 0);
    border-radius: 50px;
    background-clip: padding-box;
  }

  &::-webkit-scrollbar {
    height: calc(100% - 10px);
    margin-right: 10px;
    padding-right: 5px;
  }

  .sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 20px;
    border-bottom: 2px solid #eff1f4;
    .blue-filter {
      margin-right: 16px;
    }
    .sidebar-title {
      font-family: "Lato";
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 15px;
      color: #2d303a;
    }

    .close-sidebar {
      cursor: pointer;
      width: 12px;
      height: 12px;
    }
  }
  .sidebar-filters {
    padding: 18px 20px;
    .frequent-filter {
      margin-bottom: 16px;
    }
  }
  .sidebar-header-second {
    border-top: 2px solid #eff1f4;
  }

  .sidebar-content {
    overflow-y: auto;
    width: 364px;
    display: flex;
    flex-direction: column;
    position: relative;

    &::-webkit-scrollbar-thumb {
      background-color: #3e4356;
      margin: 5px 0px 5px 0;
      cursor: pointer;
      border: 5px solid rgba(0, 0, 0, 0);
      border-radius: 50px;
      background-clip: padding-box;
    }

    &::-webkit-scrollbar {
      height: calc(100% - 10px);
      margin-right: 10px;
      padding-right: 5px;
    }
    &.stuck {
      position: absolute;
      bottom: 78px;
      top: auto;
    }
  }

  .sidebar-footer {
    border-top: 2px solid #eff1f4;
    display: flex;
    padding: 18px 20px;
    position: fixed;
    background: #ffffff;
    width: 364px;
    bottom: 0;
    &.stuck {
      position: absolute !important;
    }
    .close-button {
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "Lato";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      text-align: center;
      color: #2d303a;
      background: #ffffff;
      border: 1px solid #dadada;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;
      height: 40px;
    }

    .close-button:disabled {
      color: #dadada;
      border-color: #dadada;
    }
  }
}
</style>
